module.exports = __webpack_public_path__ + "images/icon-board-outline-blue.9c81a8f099942bf8513d.svg";